import { useContext, useEffect } from 'react';
import { PublishedDossierContext } from '../contexts/PublishedDossierContext.js';
import { SearchEntityStateActions, } from '../reducers/SearchEntityReducer/SearchEntityReducer.js';
import { usePublishedEntities } from './usePublishedEntities.js';
import { usePublishedEntitiesSample } from './usePublishedEntitiesSample.js';
import { usePublishedEntitiesTotalCount } from './usePublishedEntitiesTotalCount.js';
export function usePublishedLoadEntitySearch(searchEntityState, dispatchSearchEntityState) {
    const { publishedClient } = useContext(PublishedDossierContext);
    // search
    const searchQuery = searchEntityState.paging
        ? searchEntityState.query
        : undefined;
    const { connection, connectionError } = usePublishedEntities(publishedClient, searchQuery, searchEntityState.paging);
    const { totalCount } = usePublishedEntitiesTotalCount(publishedClient, searchQuery);
    // sample
    const sampleQuery = !searchQuery
        ? searchEntityState.query
        : undefined;
    const { entitiesSample, entitiesSampleError } = usePublishedEntitiesSample(publishedClient, sampleQuery, searchEntityState.sampling);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateSearchResult(connection, connectionError));
    }, [connection, connectionError, dispatchSearchEntityState]);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateTotalCount(totalCount ?? null));
    }, [totalCount, dispatchSearchEntityState]);
    useEffect(() => {
        dispatchSearchEntityState(new SearchEntityStateActions.UpdateSampleResult(entitiesSample, entitiesSampleError));
    }, [entitiesSample, entitiesSampleError, dispatchSearchEntityState]);
}
//# sourceMappingURL=usePublishedLoadEntitySearch.js.map